/* ═══════════════════════════════════════════════════
   New Prospect Baptist Church — Configuration
   ═══════════════════════════════════════════════════
   
   TO GET YOUR YOUTUBE CHANNEL ID:
   1. Go to https://commentpicker.com/youtube-channel-id.php
   2. Paste: https://www.youtube.com/@newprospectbaptistchurchin6689
   3. Copy the channel ID (starts with "UC...")
   4. Paste it below as YOUTUBE_CHANNEL_ID
   ═══════════════════════════════════════════════════ */

const churchConfig = {
  // ── Church Identity ──
  name: "New Prospect Baptist Church",
  shortName: "NEW PROSPECT",
  tagline: "We Are Committed to Make Believers Out of Unbelievers.",
  subtitle: "Come as you are and experience the love of Christ.",
  mission: "We are committed to make believers out of unbelievers.",
  vision: "We are committed to glorifying God, by building New Prospect Baptist Church, by making believers out of unbelievers through our Core Values of Missions & Evangelism, Worship, Ministry, Fellowship, Discipleship, and Prayer.",
  coreValues: ["Missions / Evangelism", "Worship", "Ministry", "Fellowship", "Discipleship", "Prayer"],
  monthlyVerse: {
    reference: "Matthew 11:28-30",
    text: "Come to Me, all you who labor and are heavy laden, and I will give you rest. Take My yoke upon you and learn from Me, for I am gentle and lowly in heart, and you will find rest for your souls. For My yoke is easy and My burden is light.",
  },

  // ── Church History ──
  history: {
    founded: 1861,
    covenantDate: "October 5, 1924",
    covenantMembers: 29,
    originalName: "Prospect Church",
    source: "Jimmie Ruth Coleman, A Church with A Vision: As Seen Through My Eyes, October 2010, Dry Prong, LA",
  },

  // ── Contact ──
  address: {
    street: "111 Prospect Church Road",
    city: "Dry Prong",
    state: "LA",
    zip: "71423",
  },
  phone: "318-640-9712",
  email: "info@npbcdryprong.com",
  website: "www.npbcdryprong.com",
  eGiving: "Text NPBC to 73256",

  // ── Social Media ──
  // Replace with the church's actual Facebook page URL
  facebookPageUrl: "https://www.facebook.com/npbcdryprong",

  // ── Service Times ──
  services: [
    { name: "Sunday Fellowship", time: "9:00 AM" },
    { name: "Sunday School", time: "9:30 AM" },
    { name: "Sunday Worship", time: "10:30 AM" },
    { name: "Sunday Evening Bible Study", time: "6:00 PM" },
    { name: "Monday Men's Prayer", time: "8:30 AM" },
    { name: "Celebrate Recovery (Mon)", time: "6:00 PM" },
    { name: "Wednesday Bible Study (AM)", time: "11:00 AM" },
    { name: "Wednesday Evening", time: "6:30 PM" },
  ],

  // Hero display services (top 3 shown on landing page)
  heroServices: [
    { name: "Sunday Worship", time: "10:30 AM" },
    { name: "Wednesday Evening", time: "6:30 PM" },
    { name: "Celebrate Recovery", time: "Mon 6:00 PM" },
  ],

  // ── Leadership & Staff ──
  leaders: [
    {
      role: "Pastor",
      name: "Trey Lewis",
      desc: "Leading our congregation with wisdom, compassion, and a heart for God's people.",
    },
    {
      role: "Music Ministry / Youth Minister",
      name: "Jimmy Crabtree",
      desc: "Guiding our worship experience and investing in the next generation through music and youth ministry.",
    },
    {
      role: "Organist",
      name: "Beth White",
      desc: "Bringing beauty and reverence to our worship through music.",
    },
    {
      role: "Pianist",
      name: "Sylvia Murrell",
      desc: "Adding her musical gifts to enrich our worship services.",
    },
    {
      role: "Nursery Worker",
      name: "Jordan Jones",
      desc: "Caring for our littlest members with love and dedication.",
    },
  ],

  // ── Ministries ──
  ministries: [
    { name: "Celebrate Recovery", desc: "For hurts, habits, and hang-ups. Every Monday at 6:00 PM in the Fellowship Hall.", icon: "🙏" },
    { name: "Children's Church", desc: "During morning worship service for ages 3 through Grade 6. Nursery provided for 0-36 months.", icon: "👧" },
    { name: "Clothes Closet", desc: "Open the 2nd Saturday of each month, 9:00-11:00 AM. Volunteers needed every Monday morning 8:30-10:00 AM.", icon: "👕" },
    { name: "Prayer Quilt Ministry", desc: "Handmade prayer quilts for those in need. Contact Brenda Milligan at 318-446-3714.", icon: "🧵" },
    { name: "Detention Center Outreach", desc: "Collecting men's gently used or new blue jeans, white T-shirts, and white tube socks for Grant Parish Detention Center inmates.", icon: "❤️" },
    { name: "R.A.'s, G.A.'s & Mission Friends", desc: "Wednesday evening mission education programs for children and youth.", icon: "🌍" },
    { name: "Youth Ministry", desc: "Led by Jimmy Crabtree. Wednesday evenings and special events throughout the year.", icon: "🎵" },
    { name: "Men's Prayer Meeting", desc: "Monday mornings at 8:30 AM in the Fellowship Hall.", icon: "💪" },
  ],

  // ── YouTube Integration ──
  // Replace with your actual channel ID (see instructions above)
  YOUTUBE_CHANNEL_ID: "",
  YOUTUBE_HANDLE: "newprospectbaptistchurchin6689",

  // Fallback videos if RSS feed can't be loaded
  fallbackVideos: [
    { id: "dQw4w9WgXcQ", title: "Sunday Morning Worship", category: "sermon" },
    { id: "dQw4w9WgXcQ", title: "Bible Study Series", category: "sermon" },
    { id: "dQw4w9WgXcQ", title: "Praise & Worship", category: "worship" },
  ],

  // ── Bulletin / News Items ──
  // Update these regularly with current church announcements
  newsItems: [
    {
      date: "Mar 1",
      category: "Fundraiser",
      title: "Children's Jambalaya Fundraiser",
      desc: "Join us after church service this Sunday for a Jambalaya fundraiser supporting our Children's Ministry. All donations accepted!",
      featured: true,
    },
    {
      date: "Mar 1-8",
      category: "Missions",
      title: "Annie Armstrong Week of Prayer",
      desc: "National Week of Prayer for the Annie Armstrong Easter Offering supporting American Missions. Join us in prayer and giving.",
    },
    {
      date: "Mar 7",
      category: "Women",
      title: "Women's Conference",
      desc: "Saturday, March 7th from 10:00 AM - 1:00 PM at FBC Colfax. Covered dish lunch provided.",
    },
    {
      date: "Mar 14",
      category: "Children",
      title: "BCA Children's Ministry Day",
      desc: "Saturday, March 14th from 11:00 AM - 1:00 PM at Bethel Baptist Church.",
    },
    {
      date: "Mar 15",
      category: "Camp",
      title: "Clara Springs Camp Registration Due",
      desc: "Registration enrollment paperwork is located by Ms. Vicki Roberts' office. $25 deposit due by March 15th. Contact Ms. Vicki at 318-664-5260.",
    },
    {
      date: "Mar 18",
      category: "Church",
      title: "Business Meeting & Potluck",
      desc: "Wednesday, March 18th at 6:00 PM. Church business meeting followed by a potluck dinner. All members encouraged to attend.",
    },
  ],
};

export default churchConfig;
